import { useAuth } from '../../hooks/auth';

export function usePermissoes() {
  const { permissoes } = useAuth();

  const permite = (permissao: number) => permissoes.includes(permissao);

  const Permissoes = {
    // PERMISSÕES
    PERMISSAO_CONVIDAR_PARCEIROS: 1,
    PERMISSAO_VER_HIERARQUIA: 2,
    PERMISSAO_EDITAR_COMISSAO: 3,
    PERMISSAO_EDITAR_PERMISSOES: 4,
    PERMISSAO_EDITAR_VENDEDOR_CERTIFICADO: 5,
  } as const;

  type TypePermissoes = typeof Permissoes[keyof typeof Permissoes];

  return { permite, Permissoes };
}
